import React, { Component } from 'react';
import i18next from 'i18next'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class Downloads extends Component {
// <small>
//     <span id="downloadJwsaByRef">{i18next.t("downloadJwsaByRef" : "downloadJwsaByRef")}</span><br/>
//     <a href={this.props.url.urlUCCAgent} id="personalDsService">{i18next.t("personalDsService" : "personalDsService")}</a>
// </small>
	render () {
		return (
			<div>
				{
					this.props.connectionStatus
					? null
					: <div id="topScreen">
				        <div>
				        	{
				        		this.props.serviceTitle === "clientForService"
				        		? <h4 className="text-center">
					                <small>
					                    <span id="downloadJwsaByRef">{i18next.t("downloadJwsaByRef" : "downloadJwsaByRef")}</span><br/>
					                    <a href={this.props.base.agentForDS} id="personalDsService" style={{color: "#17a2b8"}}>{i18next.t("personalDsService" : "personalDsService")}</a>
					                </small>
					            </h4>
					            : <h4 className="text-center">
					            	<small>
					            		{
					            			i18next.t("serviceConnectionDisconnected" : "serviceConnectionDisconnected")
					            		}
					            	</small>
					            </h4>
				        	}
				            
				        </div>
				    </div>
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Downloads);


// WEBPACK FOOTER //
// ./src/components/header/Downloads.js